import {useEffect} from "react";
import {useDispatch} from "react-redux";
import {showPopUp} from "components/PopUp";
import ExitPopup from "components/IPXContents/Common/ExitPopup";
import View from "./View";
import {isMobile} from "react-device-detect";

export default function Container() {
  const dispatch = useDispatch();

  useEffect(() => {}, []);

  const onClickHome = () => {
    window.location.href = "https://redbrick.land/";
  };

  const onClickReplay = () => {
    window.location.reload();
  };

  return <View onClickHome={onClickHome} onClickReplay={onClickReplay} />;
}
